module.exports = __webpack_public_path__ + "static/woman-f-470fc3a674d88e013968a95efaecd9fb.jpg";